import { Form } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { validation } from "../../../constants";
import { UpdateUser } from "../../templates/UpdateUser";
import { PasswordProps, UserProps } from "../../templates/UpdateUser/types";
const UpdateUserPage = ({ user, onUpdateUser, userId, currentUser }: any) => {
  const history = useHistory();
  const [formRef] = Form.useForm<any>();
  const [passwordFormRef] = Form.useForm<any>();
  const [showModal, setShowModal] = useState(false);
  const [accountActive, setAccountActive] = useState(
    user?.accountStatus === "active" ? true : false
  );

  useEffect(() => {
    return formRef.resetFields();
  }, [formRef]);

  const textRules: object = validation.stringRules;

  const updateUser = async (data: object, updateType: string) => {
    await onUpdateUser(userId, { ...data, prevAccessType: user.accessType }, updateType);
  };

  const save = async (
    values: UserProps | PasswordProps | { accountStatus: boolean },
    updateType: string | null
  ) => {
    const saveDetails = () => {
      // @ts-ignore
      const { password, ...rest } = values;
      updateUser(
        { ...rest, accountStatus: accountActive ? "active" : "suspended" },
        "basicDetails"
      );
    };

    switch (updateType) {
      case "password":
        return updateUser(
          {
            // @ts-ignore
            password: values?.password,
            email: user?.email,
          },
          updateType
        );
      default:
        return saveDetails();
    }
  };

  const onFinish = async () => {
    try {
      const values: UserProps = await formRef.validateFields();

      save(values, null);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  const onFinishPasswordForm = async () => {
    try {
      const values: PasswordProps = await passwordFormRef.validateFields();
      setShowModal(false);
      save(values, "password");
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  const onCloseModal = () => {
    passwordFormRef.resetFields();
    setShowModal(false);
  };

  const onConfirmSwitch = async () => {
    setAccountActive(!accountActive);
  };

  const onCancelSwitch = () => {
    setAccountActive(accountActive);
  };

  const onBack = () => {
    return history.goBack();
  };

  return (
    <UpdateUser
      onFinish={onFinish}
      formRef={formRef}
      user={user}
      onBack={onBack}
      textRules={textRules}
      onConfirmSwitch={onConfirmSwitch}
      onCancelSwitch={onCancelSwitch}
      setShowModal={setShowModal}
      accountActive={accountActive}
      showModal={showModal}
      onCloseModal={onCloseModal}
      onFinishPasswordForm={onFinishPasswordForm}
      passwordFormRef={passwordFormRef}
      accountStatus={accountActive}
      currentUser={currentUser}
    />
  );
};
export default UpdateUserPage;
